module.exports = __webpack_public_path__ + "cd4c70727778e0674709803c33e9b487.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/group-21.svg
// module id = 689
// module chunks = 0